import { createSelector } from 'reselect'

const getCardsById = state => {
  return state['view-board'].cards
}

const createSortedCardsInListSelector = (getBoardId, getListId) => createSelector(
  [getBoardId, getListId, getCardsById],
  (boardId, listId, cardsById) =>
    Object.keys(cardsById)
      .filter(key =>
        !cardsById[key].isArchived &&
        !cardsById[key].isTemplate && 
        (listId === null
          ? (cardsById[key].listId === null && cardsById[key].boardId === boardId)
          : cardsById[key].listId === listId
        )

      )
      .sort((a, b) => cardsById[a].position - cardsById[b].position)
      .map(key => cardsById[key])
)

export default createSortedCardsInListSelector
